var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtraBed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.823,
    height: 21.254,
    viewBox: "0 0 26.823 21.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4975",
    "data-name": "Group 4975",
    transform: "translate(-8087.363 -757.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fi-rr-bed",
    d: "M16.013,5.371H10.956a4.2,4.2,0,0,0-3.722,2.28,2.919,2.919,0,0,0-1.756-.594,2.95,2.95,0,0,0-2.95,2.95,2.919,2.919,0,0,0,.3,1.264H1.686V2.843A.843.843,0,1,0,0,2.843v15.17a.843.843,0,0,0,1.686,0V16.328H18.542v1.686a.843.843,0,0,0,1.686,0V9.585A4.219,4.219,0,0,0,16.013,5.371ZM8.428,9.585a2.528,2.528,0,0,1,2.528-2.528h5.057a2.528,2.528,0,0,1,2.528,2.528v1.686H8.428Zm-4.214.421a1.264,1.264,0,1,1,1.264,1.264A1.264,1.264,0,0,1,4.214,10.007ZM1.686,14.642V12.956H18.542v1.686Z",
    transform: "translate(8087.363 759.594)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4974",
    "data-name": "Group 4974",
    transform: "translate(8097.477 757.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_475",
    "data-name": "Ellipse 475",
    fill: "#bbc6d1",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.355,
    cy: 8.355,
    rx: 8.355,
    ry: 8.355,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.355,
    cy: 8.355,
    rx: 7.355,
    ry: 7.355,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "fi-rr-plus-small",
    d: "M12.483,8.947H10.125V6.589A.589.589,0,0,0,9.536,6h0a.589.589,0,0,0-.589.589V8.947H6.589A.589.589,0,0,0,6,9.536H6a.589.589,0,0,0,.589.589H8.947v2.357a.589.589,0,0,0,.589.589h0a.589.589,0,0,0,.589-.589V10.125h2.357a.589.589,0,0,0,.589-.589h0A.589.589,0,0,0,12.483,8.947Z",
    transform: "translate(-1.181 -1.181)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraBed);
export default __webpack_public_path__ + "static/media/extra-bed.4bb8873d.svg";
export { ForwardRef as ReactComponent };